import type { RentCar, RentCarBookingHistory } from '@/libs/interfaces'

import { MOCK_STORE_ID_1, MOCK_STORE_ID_2, mockEmployees } from './seed'

/** Shared rent-car fixture data: rental fleet and booking history. */
export const mockRentCars: RentCar[] = [
  {
    rentCarRegNum: 'RNT001',
    rentCarBrand: 'Volvo',
    rentCarModel: 'V60',
    rentCarColor: 'White',
    rentCarMilage: 15000,
    rentCarActive: true,
    rentCarStatus: 'Active',
    rentCarYear: 2023,
    rentCarNotes: 'Available for daily rental',
    rentCarNumber: 'RC-1',
    storeID: MOCK_STORE_ID_1,
    createdAt: '2025-01-01T08:00:00Z',
    updatedAt: '2025-01-01T08:00:00Z',
  },
  {
    rentCarRegNum: 'RNT002',
    rentCarBrand: 'Toyota',
    rentCarModel: 'Corolla',
    rentCarColor: 'Blue',
    rentCarMilage: 22000,
    rentCarActive: true,
    rentCarStatus: 'Active',
    rentCarYear: 2022,
    rentCarNotes: 'Economy class',
    rentCarNumber: 'RC-2',
    storeID: MOCK_STORE_ID_1,
    createdAt: '2025-01-02T08:00:00Z',
    updatedAt: '2025-01-02T08:00:00Z',
  },
  {
    rentCarRegNum: 'RNT003',
    rentCarBrand: 'Tesla',
    rentCarModel: 'Model Y',
    rentCarColor: 'Red',
    rentCarMilage: 8000,
    rentCarActive: true,
    rentCarStatus: 'Active',
    rentCarYear: 2024,
    rentCarNotes: 'Electric, premium class',
    rentCarNumber: 'RC-3',
    storeID: MOCK_STORE_ID_2,
    createdAt: '2025-01-03T08:00:00Z',
    updatedAt: '2025-01-03T08:00:00Z',
  },
  {
    rentCarRegNum: 'RNT004',
    rentCarBrand: 'Skoda',
    rentCarModel: 'Octavia',
    rentCarColor: 'Silver',
    rentCarMilage: 31000,
    rentCarActive: true,
    rentCarStatus: 'Active',
    rentCarYear: 2021,
    rentCarNotes: 'Station wagon',
    rentCarNumber: 'RC-4',
    storeID: MOCK_STORE_ID_2,
    createdAt: '2025-01-04T08:00:00Z',
    updatedAt: '2025-01-04T08:00:00Z',
  },
  {
    rentCarRegNum: 'RNT005',
    rentCarBrand: 'Volkswagen',
    rentCarModel: 'Golf',
    rentCarColor: 'Black',
    rentCarMilage: 45000,
    rentCarActive: false,
    rentCarStatus: 'Inactive',
    rentCarYear: 2020,
    rentCarNotes: 'In maintenance',
    rentCarNumber: 'RC-5',
    storeID: MOCK_STORE_ID_1,
    createdAt: '2025-01-05T08:00:00Z',
    updatedAt: '2025-01-05T08:00:00Z',
  },
]

export const mockRentCarBookingHistory: RentCarBookingHistory[] = [
  {
    rentCarBookingID: 'rent-car-booking-1',
    orderID: 'order-1001',
    storeID: MOCK_STORE_ID_1,
    rentCarRegNum: 'RNT001',
    bookingStart: '2025-03-01T08:00:00Z',
    bookingEnd: '2025-03-03T17:00:00Z',
    bookedBy: mockEmployees[0]?.employeeID,
    bookingStatus: 'returned',
    submissionTime: '2025-02-28T10:00:00Z',
    createdAt: '2025-02-28T10:00:00Z',
    updatedAt: '2025-03-03T17:00:00Z',
  },
  {
    rentCarBookingID: 'rent-car-booking-2',
    orderID: 'order-1002',
    storeID: MOCK_STORE_ID_2,
    rentCarRegNum: 'RNT003',
    bookingStart: '2025-03-10T09:00:00Z',
    bookingEnd: '2025-03-12T17:00:00Z',
    bookedBy: mockEmployees[1]?.employeeID,
    bookingStatus: 'pickedup',
    submissionTime: '2025-03-09T14:00:00Z',
    createdAt: '2025-03-09T14:00:00Z',
    updatedAt: '2025-03-10T09:00:00Z',
  },
]
